// src/components/Counter.js
import React, { useState, useEffect, useRef } from 'react';

const Counter = ({ finalValue, className }) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.1,
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current && observer) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        observer.unobserve(ref.current);
      }
    };
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    let start = 0;
    const end = parseInt(finalValue, 10);
    if (start === end && end === 0) return; // If finalValue is 0, display 0 immediately
    if (start === end) return;

    const duration = 2000; // 2 seconds
    // Ensure incrementTime is at least 1ms to avoid issues with very small differences or end values
    const incrementTime = Math.max(1, Math.abs(Math.floor(duration / (end - start || 1))));

    const timer = setInterval(() => {
      start += 1;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(start);
      }
    }, incrementTime);

    return () => clearInterval(timer);
  }, [finalValue, isVisible]);

  return (
    <div className={className || "counter-value"} ref={ref}>
      {count}
    </div>
  );
};

export default Counter;